import { HttpClient } from '@angular/common/http';
import { Component, inject, signal, Signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import {
  ApiHttpResponse,
  CoachingInterval,
  Coaching,
} from '@kinomap-dev/ng-ui-lib/core';
import { CoachingPlayerComponent } from '@kinomap-dev/ng-ui-lib/player'
import { map, Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { UnitService, UnitSystem } from './services/unit.service';
import { SoundService, SoundState } from './services/sound.service';
import { ToasterService } from '@kinomap-dev/ng-ui-lib/elements';
import { TokenService } from './services/token.service';

@Component({
  selector: 'coaching-player-page',
  standalone: true,
  imports: [CoachingPlayerComponent],
  template: `
    <kin-coaching-player
      [information]="information()"
      [intervals]="intervals()"
      [unit]="unit()"
      [sound]="sound()"
      [autoplay]="!isAdmin()"
      [isAuthor]="isAdmin()"
      [isAdmin]="isAdmin()"
      [hasViewOnKinomap]="!isAdmin()"
      (thumbnailEditClick)="updateThumbnail($event.time)"
    />
  `,
})
export class CoachingPlayerPage {
  private http: HttpClient = inject(HttpClient);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private unitService: UnitService = inject(UnitService);
  private soundService: SoundService = inject(SoundService);
  private toasterService: ToasterService = inject(ToasterService);
  private tokenService: TokenService = inject(TokenService);

  subcriptions: Subscription[] = [];
  redirectUrl: string | undefined = undefined;

  unit: Signal<UnitSystem> = this.unitService.unit;
  sound: Signal<SoundState> = this.soundService.sound;
  isAdmin: Signal<boolean> = this.tokenService.isAdmin;

  information: WritableSignal<Coaching | undefined> = signal(undefined);
  intervals: WritableSignal<CoachingInterval[]> = signal([]);

  loadVideoSection(coachingId: string): void {
    this.subcriptions.push(
      this.http
        .get<ApiHttpResponse<Coaching>>(
          environment.KINOMAP_API_URL +
          `/coaching/${coachingId}?appToken=${environment.API_APP_TOKEN}`
        )
        .pipe(
          map((response: ApiHttpResponse<Coaching>) => {
            this.redirectUrl =
              environment.KINOMAP_WEBSITE_URL + '/browse/coaching/' + response.data.id;
            return response.data;
          })
        )
        .subscribe((coaching: Coaching) => {
          this.information.set(coaching);
        }),
    );
  }

  loadCoachingIntervals(coachingId: string): void {
    this.subcriptions.push(
      this.http
        .get<ApiHttpResponse<CoachingInterval[]>>(
          environment.KINOMAP_API_URL +
          `/coaching/${coachingId}/interval?appToken=${environment.API_APP_TOKEN}`
        )
        .pipe(map((response: ApiHttpResponse<CoachingInterval[]>) => response.data))
        .subscribe((coachingIntervals: CoachingInterval[]) => {
          this.intervals.set(coachingIntervals);
        }),
    );
  }

  loadCoachingData(coachingId: string): void {
    this.loadVideoSection(coachingId);
    this.loadCoachingIntervals(coachingId);
  }

   updateThumbnail(
    time: number,
  ): void {
    this.http
      .patch(`${environment.KINOMAP_API_URL}/coaching/${this.information()!.hash_id}/updateThumbnail?appToken=${environment.API_APP_TOKEN}`,
        { time }
      ).subscribe({
        next: () => this.toasterService.success('Miniature', 'La miniature a bien été mise à jour.'),
        error: () => this.toasterService.error('Miniature', 'Erreur lors de la mise à jour de la miniature.'),
      });
  }

  ngOnInit(): void {
    this.subcriptions = [
      ...this.subcriptions,
      this.route.params.subscribe((params: Params) => {
        const coachingId: string = params['coachingId'];
        this.loadCoachingData(coachingId);
      }),
    ];
  }

  ngOnDestroy(): void {
    this.subcriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }
}
